import axiosClient from "./axiosClient";

// Login Function
export const login = async (values, type) => {
  try {
    const response = await axiosClient.post(
      type === "admin"
        ? `/auth/admin/login`
        : type === "user"
        ? `/auth/user/login`
        : `/auth/sadmin/login`,
      values,
      { withCredentials: true } // Ensures cookies are saved
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: `Login failed ${error.request.response}`,
      }
    );
  }
};

export const resetpassword = async (values, type) => {
  try {
    const response = await axiosClient.post(
      type === "admin"
        ? `/admins/resetpassword/${values.email}`
        : type === "user"
        ? `/users/resetpassword/${values.email}`
        : "",
      { language: values.language || "E" },
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: `Login failed ${error.request.response}`,
      }
    );
  }
};

// Logout Function
export const logout = async () => {
  try {
    await axiosClient.post(
      `/auth/logout`,
      {},
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    // Preserve language preference before clearing storage
    const savedLanguage = localStorage.getItem("appLanguage");

    localStorage.clear(); // Clear client-side session cache
    sessionStorage.clear(); // Clear session storage cache

    // Restore language preference after clearing
    if (savedLanguage) {
      localStorage.setItem("appLanguage", savedLanguage);
    }

    // Forces reload to clear client-side session cache
    window.location.href = "/login";
  } catch (error) {
    console.error("Logout failed", error);
  }
};

// Check if User is Authenticated
export const checkAuth = async () => {
  try {
    const response = await axiosClient.get(`/auth/protected`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      console.warn("Unauthorized, attempting refresh...");

      try {
        await axiosClient.post(`/auth/refresh`);

        // console.log("Refresh response:", refreshResponse);
        const retryResponse = await axiosClient.get(`/auth/protected`);
        return retryResponse.data;
      } catch (refreshError) {
        console.error("Token refresh failed:", {
          message: refreshError.message,
          response: refreshError,
          data: refreshError.response?.data,
        });
        return null;
      }
    }
    console.error("Auth check failed", error);
    return null;
  }
};
